// extracted by mini-css-extract-plugin
module.exports = {"cardBtn":"index_cardBtn_1CjJv","tabs":"index_tabs_3UgJ1"};